<template>
  <div class="content">
    <div class="content-back">
      <el-button @click="goback">返回列表</el-button>
    </div>
    <div class="content-caption">
      {{examResult.examName}}
    </div>
    <div class="content-info">
      <label class="content-info-note">姓名：{{examResult.userName}}</label>
      <label class="content-info-note content-info-time">考试时间：{{getTime(examResult.creationTime)}}</label>
      <div class="content-info-grade">
        考试分数：<label class="content-info-grade-value">{{examResult.score}}分</label>
        <label class="content-info-grade-result">{{examResult.isPass?"及格":"不及格"}}</label>
      </div>
    </div>
    <div class="content-list">
      <div class="content-list-item" v-for="(item, index) in examResultInfo.examResultList" :key="index">
        <div class="content-list-item-content">
          <div class="content-list-item-content-title">
            <label class="content-list-item-content-title-order">{{index+1}}</label>
            <label class="content-list-item-content-title-text">{{item.examQuestions.questionsList}}</label>
            <span style="float:right;">
              <label>本题得分:
                <span style="color: red; font-size: 1.2rem;">{{item.isTrue?item.questionScore:0}}</span>
              </label>
            </span>
          </div>
          <div class="content-list-item-content-option">
            <template
            v-for="(op, index2) in item.examQuestions.examQuestionsOptions"
            :label="index2"
            >
              <el-radio
              :class="{
                'content-list-item-content-option-radio':true,
                'content-list-item-content-option-error': isCheckedRadioError(item,op)
              }"
              :key="index2"
              :label="op.optionsList"
              v-model="item.Selectedlabel"
              size="large"
              v-if="item.examQuestions.type==0"
              disabled
              >
                {{op.optionsList}}
              </el-radio>
            </template>

            <el-checkbox-group v-model="item.checkedTrues" >
                <template
                v-for="(op, index2) in item.examQuestions.examQuestionsOptions"
                :label="index2"
                >
                  <el-checkbox
                  :class="{
                    'content-list-item-content-option-radio':true,
                    'content-list-item-content-option-error':isCheckedCheckboxError(item,op)
                  }"
                  :key="index2"
                  :label="op.optionsList"
                  size="large"
                  v-if="item.examQuestions.type==1"
                  disabled/>
                </template>
            </el-checkbox-group>

            <el-input
              :key="index2"
              v-model="item.examResultOptionsList[0].options_results"
              class="content-left-abstract-input"
              :rows="3"
              type="textarea"
              v-if="item.examQuestions.type==2"
              disabled
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
// import XEUtils from "xe-utils";
import { useRouter } from "vue-router";
import {GetExamResultInfoById} from "@api/Exam/ApiExamDataCenter";
import { dateFormat } from "@/util/utils.js";

export default {
  name: "ExamEdit",
  data() {
    return {
      examResult:{},
      router: useRouter(),
      examResultInfo:{},
      // dataList:[
      //   {type:"多选题", code:1, answer:0, checked:false, grade:5, title:"依据《安全生产法》的规定，从业人员发现直接危及人身安全的紧急情况时，可以（）后撤离现场。", list:[{title:"A. 经安全管理人员同意", checked:true, userChecked:true},{title:"B. 采取可能的应急措施", checked:false, userChecked:true},{title:"C.经现场负责人同意", checked:false, userChecked:false},{title:"D. 经单位负责人同意", checked:true, userChecked:true}]},
      //   {type:"单选题", code:0, answer:0, userAnswer:0, checked:false, grade:5, title:"依据《安全生产法》的规定，从业人员发现直接危及人身安全的紧急情况时，可以（）后撤离现场。", list:[{title:"A. 经安全管理人员同意"},{title:"B. 采取可能的应急措施"},{title:"C.经现场负责人同意"},{title:"D. 经单位负责人同意"}]},
      //   {type:"单选题", code:0, answer:0, userAnswer:1, checked:false, grade:5, title:"依据《安全生产法》的规定，从业人员发现直接危及人身安全的紧急情况时，可以（）后撤离现场。", list:[{title:"A. 经安全管理人员同意"},{title:"B. 采取可能的应急措施"},{title:"C.经现场负责人同意"},{title:"D. 经单位负责人同意"}]},
      //   {type:"单选题", code:0, answer:2, userAnswer:2, checked:false, grade:5, title:"依据《安全生产法》的规定，从业人员发现直接危及人身安全的紧急情况时，可以（）后撤离现场。", list:[{title:"A. 经安全管理人员同意"},{title:"B. 采取可能的应急措施"},{title:"C.经现场负责人同意"},{title:"D. 经单位负责人同意"}]},
      //   {type:"简答题", code:2, answer:0, userAnswer:"just for test~", checked:false, grade:5, title:"依据《安全生产法》的规定，从业人员发现直接危及人身安全的紧急情况时，可以（）后撤离现场。"},
      // ],
    }
  },
  methods: {
    //多选题
    isCheckedCheckboxError(item,op){
      if(!item.examResultOptionsList){
        //这题可能没做 默认选第一个吧(那万一第一个是对的呢?)
        return true
      }
      let bl = false
      item.examResultOptionsList.forEach(x=>{
        if(x.options_results == op.number && !op.isTrue) bl  = true
      })
      return bl
    },
    //单选题
    isCheckedRadioError(item,op){
      if(!item.examResultOptionsList){
        //这题可能没做 默认选第一个吧(那万一第一个是对的呢?)
        return true
      }
      let bl = false
      item.examResultOptionsList.forEach(x=>{
        if(x.options_results == op.number && !op.isTrue) bl  = true
      })
      return bl
    },
    getAnswer(number,examResultOptionsList,i){
      if(!examResultOptionsList) return ''
      examResultOptionsList.forEach(ele => {
        if(ele.options_results==number)return true

      });
    },
    getTime(time){
      return dateFormat("YYYY-mm-dd HH:MM:SS",time);
    },
    getData(){
      var _this = this;
      const loading = this.loading()
      GetExamResultInfoById(this.examResult.id).then(res=>{
        res.examResultList.forEach(x=>{

          x.Selectedlabel = ''

          if(x.examQuestions.type==0){
            x.Selectedlabel = x.examQuestions.examQuestionsOptions.find(t=>t.isTrue).optionsList
          }

          if(x.examQuestions.type==1){
           x.checkedTrues = []
           x.examQuestions.examQuestionsOptions.forEach(t=>{
             if(t.isTrue)x.checkedTrues.push(t.optionsList)
           })
          }
        })
        _this.examResultInfo = res
        loading.close();
      }).catch(res=>{
        loading.close();
        this.$message.error(res.message)
      })
    },
    goback() {
      this.$router.push({
        name: "考试成绩报告",
        params: {
          from: "ExamDataCenterDetail",
          isReplace: true,
        },
      });
    },
  },
  mounted() {
    this.examResult = JSON.parse(localStorage.getItem('ExamDataCenter_ExamResult'))
    this.getData()
  }
}
</script>
<style lang="less" scoped>
  .spring{
    flex: 1;
  }
  :deep(.el-checkbox__input.is-checked .el-checkbox__inner),
  :deep(.el-radio__input.is-checked .el-radio__inner){
    background-color: #0747A6;
    border-color: #0747A6;
  }
  :deep(.el-checkbox__input.is-checked + .el-checkbox__label),
  :deep(.el-radio__input.is-checked + .el-radio__label){
    color: #0747A6;
  }

  .content{
    flex: 1;
    display: flex;
    flex-direction: column;
    background: #FFFFFF;
    box-sizing: border-box;
    height: 100%;
    padding: 10px;
    overflow-y: scroll;
    margin-right: 8px;

    &-caption{
      font-size: 24px;
      font-weight: 500;
      color: #33404E;
      padding-bottom: 10px;
      border-bottom: 1px solid #D8DEE8;
      // height: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &-info{
      background: #e4e4e4;
      border-radius: 2px 2px 2px 2px;
      display: flex;
      align-items: center;
      flex-direction: row;
      height: 56px;
      padding: 0 10px;

      &-note{
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #33404E;
      }
      &-time{
        padding-left: 20px;
      }
      &-grade{
        flex: 1;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        font-size: 16px;
        font-weight: 500;
        color: #33404E;

        &-value{
          font-size: 16px;
          font-weight: 500;
          color: #F7971E;
        }
        &-result{
          font-size: 16px;
          font-weight: 500;
          color: #14A386;
          padding-left: 10px;
        }
      }

    }
    &-list{
      flex: 1;
      width: 100%;
      display: flex;
      flex-direction: column;
      overflow-y: scroll;

      &-item{
        width: 100%;
        display: flex;
        flex-direction: row;
        margin: 6px 0;

        &-content{
          flex: 1;
          display: flex;
          flex-direction: column;
          border-radius: 2px 2px 2px 2px;
          padding: 10px;

          &-title{
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            padding-bottom: 5px;

            &-order{
              font-size: 10px;
              font-weight: 400;
              color: #FFFFFF;
              background: #0747A6;
              border-radius: 2px 2px 2px 2px;
              padding: 0 8px;
              display: flex;
              margin-right: 5px;
              height: 24px;
              line-height: 24px;
            }
            &-type{
              font-size: 10px;
              font-weight: 400;
              color: #0747A6;
              border-radius: 2px 2px 2px 2px;
              border: 1px solid #0747A6;
              padding: 0 5px;
              margin-right: 5px;
              height: 24px;
              line-height: 24px;
              box-sizing: border-box;
            }
            &-text{
              flex: 1;
              font-size: 16px;
              font-weight: 400;
              color: #000000;
              margin-right: 5px;
            }
            &-grade{
              width: 40px;
              border-radius: 2px 2px 2px 2px;
              border: 1px solid #B8C2C8;
              font-size: 14px;
              font-weight: 400;
              color: #F7971E;
              text-align: center;
              margin-right: 2px;
              height: 24px;
              line-height: 24px;
              box-sizing: border-box;
            }
            &-unit{
              font-size: 12px;
              font-weight: 400;
              color: #24335A;
              height: 24px;
              line-height: 24px;
            }
          }
          &-option{
            display: flex;
            flex-direction: column;

            &-radio{
              display: block;
              font-size: 14px;
              font-weight: 400;
              color: #000000;
              padding: 10px;
            }

            &-error{
              display: block;
              :deep(.el-checkbox__input .el-checkbox__inner),
              :deep(.el-radio__input .el-radio__inner){
                background-color: #FE6E6F;
                border-color: #FE6E6F;

              }
              :deep(.el-checkbox__input + .el-checkbox__label),
              :deep(.el-radio__input + .el-radio__label){
                color: #FE6E6F;
              }
            }

          }
          &-oprate{
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: center;
            padding-top: 10px;

            &-note{
              font-size: 12px;
              font-weight: 400;
              color: #24335A;
            }
            &-img{
              width: 16px;
              height: 16px;
              padding: 2px 5px;
            }
          }
        }
      }
    }
  }
</style>